<template>
  <div class="card-form">
    <PageMain
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @review="review"
    >
      <PageHeader
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      />
      <pagination
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageMain>

    <Review
      :visible.sync="reviewOpts.visible"
      :bflowTaskCode="reviewOpts.bflowTaskCode"
      :businessType="reviewOpts.businessType"
      :businessCode="reviewOpts.businessCode"
      @reload="reload"
    />
  </div>
</template>
<script>
import PageMain from './main.vue'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import Review from '../review/index.vue'
export default {
  mixins: [BaseTable],
  components: { PageMain, PageHeader, Review },
  data() {
    return {
      usePage: true,
      reviewOpts: {
        visible: false,
        bflowTaskCode: '',
        businessType: '',
        businessCode: '',
      },
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .approvalCenterTodoListApi({ ...form, ...this.page })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    review({ bflowTaskCode, businessType, businessCode } = {}) {
      if (!bflowTaskCode) return

      this.reviewOpts = {
        visible: true,
        bflowTaskCode,
        businessType,
        businessCode,
      }
    },
  },
}
</script>
